/**
 * Core tournament enums, in a dependency-free base module.
 *
 * These live here (not in tournaments.ts) to break a circular import: the
 * display-map module (tournamentDisplayMaps.ts) builds `Record<BracketType, …>`
 * objects with computed enum-value keys at module-load time, and tournaments.ts
 * re-exports those maps — so importing the enums from tournaments.ts created a
 * cycle that left BracketType `undefined` when the maps evaluated, crashing at
 * runtime ("Cannot read properties of undefined (reading 'SINGLE_ELIMINATION')").
 * A no-import base module both files depend on removes the cycle.
 */

import {CompetitionBracketType as BracketType} from "@devour/client";

// Re-export the generated client enum under its historical `BracketType` name.
// This is NOT a local copy — the hand-maintained duplicate that used to live here
// drifted on GROUPS_KNOCKOUT and tripped the enum-parity gate. Source the enum
// from @devour/client so it can never drift again.
export {BracketType};

/** @deprecated Use BracketType instead - kept for backwards compatibility */
export const TournamentFormat = BracketType;

export enum TournamentStatus {
    DRAFT = "DRAFT",
    REGISTRATION = "REGISTRATION",
    READY = "READY",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED",
}
